import { useIntl, defineMessages } from 'react-intl';

import cx from 'classnames';
import config from '@plone/registry';

import Slides from '@redturtle/qubicaamf-theme/components/Blocks/ImageGallery/Slides';

const ImageGalleryTemplate = (props) => {
  const intl = useIntl();
  const Container = config.getComponent('Container').component || 'div';

  const slides = props.items.map((item) => {
    return {
      '@id': item['@id'],
      title: item.title,
      description: item.Description,
      image: item,
      link: item,
      linkMore: undefined,
    };
  });

  return (
    <Container
      className={cx('block-imagegallery-container', {
        'has--fullwidth--true': props.full_width,
      })}
    >
      {props?.items?.length > 0 ? (
        <Slides
          slides={slides}
          listing={true}
          editMode={props.isEditMode}
          show_description={props.show_description}
          show_title={props.show_title}
        />
      ) : (
        <div>{intl.formatMessage(messages.help_text)}</div>
      )}
    </Container>
  );
};

export default ImageGalleryTemplate;

const messages = defineMessages({
  help_text: {
    id: 'help_text',
    defaultMessage: 'Add slides from the sidebar',
  },
});
